export const namespace = 'canalplus.block.oneshop.updating_options_summary';
export { default as Component } from './components/Summary';
export { default as propsFormatter } from './propsFormatter';
